import { render, staticRenderFns } from "./titledBox.vue?vue&type=template&id=02aeffef&"
import script from "./titledBox.vue?vue&type=script&lang=js&"
export * from "./titledBox.vue?vue&type=script&lang=js&"
import style0 from "./titledBox.vue?vue&type=style&index=0&id=02aeffef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports